import React from 'react';
import { Container } from '@mui/material';
import PricingCalculator from '../components/PricingCalculator';

const PricingCalculatorPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <PricingCalculator />
    </Container>
  );
};

export default PricingCalculatorPage;